var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-avator-dropdown"},[_c('Dropdown',{on:{"on-click":_vm.handleClick}},[_c('Avatar',{attrs:{"src":_vm.userAvator}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }